export const environment = {
  production: false,
  apiUrl: 'https://sportiq-competition-api.digi4dev.ma',
  baseDomain: 'sportiq-competition.digi4dev.ma',
  devFederationSlug: 'frmtt',
  version: '1.0.0'
};
